// Pure builder for a draft_ticket card's prefilled report body (Task 6.1, F-12).
// The transcript itself is never attached (SA6) — only what the model put in the draft.

import type { AiTicketDraft } from "@checklist/shared";

function section(label: string, value: string | undefined): string {
  const trimmed = value?.trim();
  return trimmed ? `${label}\n${trimmed}` : "";
}

/** Builds a FeedbackForm-ready body from an assistant-drafted ticket, omitting empty sections. */
export function ticketBody(draft: AiTicketDraft): string {
  return [
    section("Summary", draft.title),
    section("Steps", draft.steps),
    section("Expected", draft.expected),
    section("What happened", draft.actual),
  ]
    .filter(Boolean)
    .join("\n\n");
}
